
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casinos/collections/[name]",
      function () {
        return require("private-next-pages/casinos/collections/[name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casinos/collections/[name]"])
      });
    }
  